<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Ngày' }}
                </div>
                <div class="child-w-80">
                  <CalendarSelect
                    v-model="searchParams.dateFrom"
                    style="display: block; width: 100%"
                    mode="date"
                  />
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Số ngày hiển thị' }}
                </div>
                <div class="child-w-80">
                  <input v-model="searchParams.numOfDays" type="number" />
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label" style="visibility: hidden">
                  {{ 'includeHUInPercentOcc' }}
                </div>
                <div
                  style="
                    background: #f0f0f5;
                    padding: 0 8px;
                    margin: 0;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    border-radius: 5px;
                  "
                >
                  <div class="checkbox-wrap">
                    <input
                      id="includeHUInPercentOcc"
                      v-model="searchParams.includeHUInPercentOcc"
                      type="checkbox"
                    />
                    <label
                      for="includeHUInPercentOcc"
                      style="color: #606266; font-size: 14px"
                      >{{ 'Bao gồm Nội bộ trong Công suất' }}</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label" style="visibility: hidden">
                  {{ 'includeHUInPercentOcc' }}
                </div>
                <div
                  style="
                    background: #f0f0f5;
                    padding: 0 8px;
                    margin: 0;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    border-radius: 5px;
                  "
                >
                  <div class="checkbox-wrap">
                    <input
                      id="includeOOOInPercentOcc"
                      v-model="searchParams.includeOOOInPercentOcc"
                      type="checkbox"
                    />
                    <label
                      for="includeOOOInPercentOcc"
                      style="color: #606266; font-size: 14px"
                      >{{ 'Bao gồm phòng OOO trong Công suất' }}</label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :header-height="60"
        :rows="rows"
        :get-row-class="getRowClass"
        class="agGrid room-availability"
        :context="context"
        dom-layout="scroll"
        :suppress-row-click-selection="true"
      />
    </div>
    <!-- <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="pageParams.totalPage"
        :page-num="pageParams.pageNum"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div> -->

    <div class="button-containers mb-0">
      <button class="btn primary small" @click="fnGetRoomAvailableExcel">
        {{ 'Xuất excel' }}
      </button>
    </div>

    <BookingStatusDialog
      v-model="dialogBookingStatusVisible"
      :book-status-search="bookStatusSearch"
    />
  </div>
</template>

<script>
/* eslint-disable */
import paginationMixin from '@/mixins/paginationMixin'
import CellRenderDateHeader from './components/CellRenderDateHeader.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import { CellRenderOpenDialogWhenCLicked } from '@/utils/cellRenders'
import BookingStatusDialog from './components/BookingStatusDialog.vue'

import * as dayjs from 'dayjs'
import {
  getRoomAvailable,
  getRoomAvailableExcel
} from '@/api/reception/reception'

export default {
  components: {
    CellRenderDateHeader,
    CalendarSelect,
    CellRenderOpenDialogWhenCLicked,
    BookingStatusDialog
  },
  mixins: [paginationMixin],
  data() {
    return {
      context: null,

      searchParams: {
        dateFrom: dayjs().format('YYYY-MM-DD'),
        numOfDays: 15,
        includeHUInPercentOcc: false,
        includeOOOInPercentOcc: false
      },
      defaultSearchParams: {
        dateFrom: dayjs().format('YYYY-MM-DD'),
        numOfDays: 15,
        includeHUInPercentOcc: true,
        includeOOOInPercentOcc: true
      },

      columns: [
        {
          headerName: 'Hạng phòng',
          field: 'room_level_nm',
          width: 200
        },
        {
          headerName: 'Số lượng phòng',
          field: 'total_room',
          width: 150
        }
      ],
      rows: [],
      loading: false,

      // dialog
      dialogBookingStatusVisible: false,
      bookStatusSearch: {
        date: null,
        bookingStatus: [],
        roomTypeId: null,
        specialServiceList: null,
        isInternal: false,
        isFree: false,
        isOneDayBooking: false,
        info: null,
        tab: 1,
        totalPage: null,
        pageSize: 10,
        currentPage: 1
      }
    }
  },

  computed: {},

  beforeMount() {
    this.context = { componentParent: this }
  },

  mounted() {
    this.searchParams = { ...this.defaultSearchParams }
    this.genDate(this.searchParams.dateFrom, this.searchParams.numOfDays)
    this.fnGetRoomAvailable()
    // this.$refs.agGrid.gridApi.sizeColumnsToFit()
  },

  methods: {
    // utils
    genDate(start, numberOfDates) {
      if (start && numberOfDates) {
        const dateFrom = dayjs(start, 'YYYY-MM-DD')
        const resultCols = [
          {
            headerName: 'Hạng phòng',
            field: 'room_level_nm',
            width: 200
          },
          {
            headerName: 'Số lượng phòng',
            field: 'total_room',
            width: 150
          }
        ]

        for (let i = 0; i < numberOfDates; i++) {
          const col = {
            // headerName: dateFrom.add(i, 'day').format('DD/MM-dddd'),
            field: `Day_${dateFrom.add(i, 'day').format('YYYY-MM-DD')}`,
            headerComponent: 'CellRenderDateHeader',
            headerComponentParams: {
              value: dateFrom.add(i, 'day').format('DD/MM-dddd')
            },
            cellRenderer: 'CellRenderOpenDialogWhenCLicked',
            cellRendererParams: params => {
              return {
                refName: 'agGrid',
                clickable:
                  +params.value < +params.data.total_room ? true : false
              }
            }
          }
          if (numberOfDates > 9) {
            col.maxWidth = 100
            col.minWidth = 100
          } else {
            col.flex = 1
          }
          resultCols.push(col)
        }
        this.columns = resultCols
      }
    },

    getRowClass(params) {
      let color = null

      const hotelId = params.data.hotel_id
      switch (hotelId) {
        // Khách sạn đoàn tàu
        case 46:
          color = 'green'
          break
        // Khu cắm trại
        case 45:
          color = 'yellow'
          break
        // Làng cổ tích
        case 44:
          color = 'red'
          break
        // Nebula
        case 47:
          color = 'purple'
          break
        // Nhà sàn thái
        case 48:
          color = 'brown'
          break
        default:
          color = 'white'
          break
      }
      return 'room-level-row room-level-row--' + color
    },

    // handle event
    opendialogByCellRenderComp(gridName, colName, rowIdx, params) {
      switch (gridName) {
        case 'agGrid':
          this.dialogBookingStatusVisible = true
          this.bookStatusSearch = {
            date: colName.slice('Day_'.length),
            bookingStatus: null,
            roomTypeId: params.data.room_level_id,
            specialServiceList: null,
            isInternal: false,
            isFree: false,
            isOneDayBooking: false,
            info: null,
            tab: 1,
            totalPage: null,
            pageSize: 10,
            currentPage: 1
          }
          break
        default:
          break
      }
    },
    // pagination
    // async onPageChanged(pageNum) {
    //   this.pageParams.pageNum = pageNum
    //   await this.fnGetListAgent()
    // },
    // async onPageSizeChange(pageSize) {
    //   this.pageParams.pageSize = pageSize
    //   this.pageParams.pageNum = 1
    //   await this.fnGetListAgent()
    // },

    // btn
    onSearch() {
      this.genDate(this.searchParams.dateFrom, this.searchParams.numOfDays)
      this.fnGetRoomAvailable()
    },
    onResetSearch() {
      this.searchParams = { ...this.defaultSearchParams }
      this.rows = []
      this.columns = [
        {
          headerName: 'Hạng phòng',
          field: 'room_level_nm'
        },
        {
          headerName: 'Số lượng phòng',
          field: 'total_room'
        }
      ]
      this.onSearch()
    },

    // handle api call
    fnGetRoomAvailable() {
      this.loading = true
      getRoomAvailable(this.searchParams)
        .then(res => {
          if (!res.is_error) {
            this.rows = []
            let list = _.chain(res.data)
              .groupBy('hotel_nm')
              .map((value, key) => {
                return {
                  groupName: key,
                  groupList: value
                }
              })
              .value()

            list.forEach(group => {
              this.rows.push({
                name: group.groupName,
                isFullWidthRow: true
              })
              group.groupList.forEach(item => this.rows.push(item))
            })

            this.rows.push({
              isFullWidthRow: true,
              name: null // empty line
            })
            this.rows = this.rows.concat(res.map.statistics)
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    fnGetRoomAvailableExcel() {
      getRoomAvailableExcel(this.searchParams)
        .then(res => {
          if (!res?.is_error) {
            const href = URL.createObjectURL(res)
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              `room-available-${dayjs(this.searchParams.dateFrom).format(
                'YYYYMMDD'
              )}-${dayjs(this.searchParams.dateFrom)
                .add(this.searchParams.numOfDays, 'day')
                .format('YYYYMMDD')}.xlsx`
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()

            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    }
  }
}
</script>
